import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { isHandledApiError, shouldThrowOnError } from '../error';
import { getGlobalErrorHandler } from './global-error-handler-ref';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (!isHandledApiError(error)) return;
      getGlobalErrorHandler()?.(error);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (mutation.options.onError) return;
      if (!isHandledApiError(error)) return;
      getGlobalErrorHandler()?.(error);
    },
  }),
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
      throwOnError: shouldThrowOnError,
    },
    mutations: {
      retry: 1,
      throwOnError: shouldThrowOnError,
    },
  },
});
